<script>
import tierPricing from './tier-pricing.vue'
import sizePricing from './size-pricing.vue'
import {getMAList} from "@/api/zipCode";
import {batchSaveZonePrices, getPricingMatrixData, getTierDropdownlist, getTierPricing} from "@/api/price";
export default {
  components: {
    tierPricing,sizePricing
  },
  data() {
    return {
      unsetDefaultValue: 'Unset',
      options: [],
      codes: [],
      names: [],
      data: [],
      show_edit: false,
      operationStack: [], // 存储操作记录的栈
      undoStack: [], // 存储撤销记录的栈
      leftBtns: [
        {
          label: 'Pricing matrix',
          name: 'pricingMatrix'
        },
        {
          label: 'Tier Pricing',
          name: 'tierPricing',
        },
        {
          label: 'Size Pricing',
          name: 'sizePricing',
        }
      ],
      rightBtns: [
        {
          label: 'Edit',
          name: 'Edit',
          bgColor: '#e95646',
        }
      ],
      priceActiveName:0,
      priceLoading:false,
      selectArea:'',
      areaMenuItems:[],
      tirelist:[],
    }
  },
  created() {
    this.getInitData()
  },
  methods: {
    getTierDropdownlistHandle(){
      getTierDropdownlist({
        ma_code:this.selectArea
      }).then(res => {
        this.tirelist = res.data.list
        this.tirelist.forEach(item => {
          if (item.is_set == 1){
            item.disabled = true
          }
        })
      })
    },
    getTireList() {
      getTierPricing({
        ma_code:this.selectArea
      }).then(res => {
        this.priceLoading = false
         this.options =res.data.list
      })
    },
    getInitData(){
      this.priceLoading = true
      getMAList({
        page:1,
        limit:100
      }).then(res=>{
        this.priceLoading = false
        this.areaMenuItems = res.data.list
        this.selectArea = this.areaMenuItems[0]?.ma_code
        this.getTierDropdownlistHandle()
          this.getPricingMatrixDataHandle()
          this.getTireList()
      })
    },
    getPricingMatrixDataHandle(){
      getPricingMatrixData({
        ma_code:this.selectArea,
      }).then(res=>{
        this.priceLoading = false
        const result = this.changeInitData(res.data);
        this.codes = result.codes;
        this.names = result.names;
        this.data = result.data
        console.log(this.data,'data')
      })
    },
    changeInitData(originalData) {
      const codes = originalData.headers?.map(header => header.code);
      const names = originalData.headers?.map(header => header.name);

      const data = codes.map((code, index) => ({
        code,
        name: names[index],
        cells: Array(codes.length).fill('Unset'),
        dropdowns: Array(codes.length).fill(false),
        cellColors: [],
      }));

      // 遍历 matrix 对象，更新 data 中的单元格值
      for (const [rowCode, rowData] of Object.entries(originalData.matrix)) {
        for (const [colCode, cellData] of Object.entries(rowData)) {
          const rowIndex = codes.indexOf(rowCode);
          const colIndex = codes.indexOf(colCode);

          if (rowIndex !== -1 && colIndex !== -1) {
            const { tier_id, name, price, color } = cellData;
            if (tier_id !== 0) {
              data[rowIndex].cells[colIndex] = `${price}`;
              data[rowIndex].dropdowns[colIndex] = false;
              data[rowIndex].cellColors[colIndex] = color;
            }
          }
        }
      }
      return {
        codes,
        names,
        data,
      };
    },
    toggleDropdown(rowIndex, cellIndex) {
      if (this.show_edit) {
        this.data.forEach((v,i)=>{
          this.data[i].dropdowns = this.data[i].dropdowns.map(() => false);
        })
        this.$set(this.data[rowIndex].dropdowns, cellIndex, true);
      }
    },
// 更新数据并记录操作
    selectOption(rowIndex, cellIndex, option) {
      const oldValue = this.data[rowIndex].cells[cellIndex];
      this.data[rowIndex].dropdowns[cellIndex] = false;

      // 更新当前单元格
      this.$set(this.data[rowIndex].cells, cellIndex, option.price);
      this.$set(this.data[rowIndex].cellColors, cellIndex, option.color);

      // 找到需要同步更新的单元格
      const currentRowCode = this.data[rowIndex].code;
      const currentCellCode = this.codes[cellIndex]; // 获取当前单元格的代码

      // 查找对应的行和列索引
      const correspondingRowIndex = this.codes.indexOf(currentCellCode); // 找到当前单元格的代码在 codes 中的索引
      const correspondingCellIndex = this.codes.indexOf(currentRowCode); // 找到当前行代码在 codes 中的索引

      console.log(this.data[rowIndex].cells, this.data[cellIndex].cells);
      console.log(correspondingRowIndex, correspondingCellIndex, 'correspondingCellIndex');

      // 如果对应的单元格存在，进行更新
      if (correspondingRowIndex !== -1 && correspondingCellIndex !== -1) {
        // 更新对应单元格的数据
        this.$set(this.data[correspondingRowIndex].cells, correspondingCellIndex, option.price);
        this.$set(this.data[correspondingRowIndex].cellColors, correspondingCellIndex, option.color);
      }

      // 记录操作
      this.operationStack.push({ rowIndex, cellIndex, oldValue, newValue: option.price });
    },

// 撤销操作
    undoHandle() {
      if (this.operationStack.length > 0) {
        const lastOperation = this.operationStack.pop();
        const { rowIndex, cellIndex, oldValue } = lastOperation;

        // 更新当前单元格
        this.$set(this.data[rowIndex].cells, cellIndex, oldValue);
        this.$set(this.data[rowIndex].cellColors, cellIndex, this.options.find(option => option.price === oldValue)?.color || '');

        // 找到需要同步更新的单元格
        const currentRowCode = this.data[rowIndex].code;
        const currentCellCode = this.codes[cellIndex];

        // 查找对应的行和列索引
        const correspondingRowIndex = this.codes.indexOf(currentCellCode);
        const correspondingCellIndex = this.codes.indexOf(currentRowCode);

        // 如果对应的单元格存在，进行更新
        if (correspondingRowIndex !== -1 && correspondingCellIndex !== -1) {
          this.$set(this.data[correspondingRowIndex].cells, correspondingCellIndex, oldValue);
          this.$set(this.data[correspondingRowIndex].cellColors, correspondingCellIndex, this.options.find(option => option.price === oldValue)?.color || '');
        }

        // 将操作加入撤销栈
        this.undoStack.push(lastOperation);
      } else {
        console.log('No more undo operations available.');
      }
    },

// 重做操作
    redoHandle() {
      if (this.undoStack.length > 0) {
        const operation = this.undoStack.pop();
        const { rowIndex, cellIndex, newValue } = operation;

        // 更新当前单元格
        this.$set(this.data[rowIndex].cells, cellIndex, newValue);
        this.$set(this.data[rowIndex].cellColors, cellIndex, this.options.find(option => option.price === newValue)?.color || '');

        // 找到需要同步更新的单元格
        const currentRowCode = this.data[rowIndex].code;
        const currentCellCode = this.codes[cellIndex];

        // 查找对应的行和列索引
        const correspondingRowIndex = this.codes.indexOf(currentCellCode);
        const correspondingCellIndex = this.codes.indexOf(currentRowCode);

        // 如果对应的单元格存在，进行更新
        if (correspondingRowIndex !== -1 && correspondingCellIndex !== -1) {
          this.$set(this.data[correspondingRowIndex].cells, correspondingCellIndex, newValue);
          this.$set(this.data[correspondingRowIndex].cellColors, correspondingCellIndex, this.options.find(option => option.price === newValue)?.color || '');
        }

        // 将操作加入操作栈
        this.operationStack.push(operation);
      } else {
        console.log('No more redo operations available.');
      }
    },
    // 保存操作
    saveHandle() {
      // 执行保存逻辑
      this.operationStack = []; // 清空操作栈
      this.undoStack = []; // 清空撤销栈
    },
    leftClickHandler(name){
      if (name === 'pricingMatrix') {
        this.show_edit = false;
        this.priceActiveName = 0;
        this.rightBtns = [
          {
            label: 'Edit',
            name: 'Edit',
            bgColor: '#e95646',
          }
        ]
      }
      if (name === 'tierPricing') {
        this.priceActiveName = 1;
        this.rightBtns = [
          {
            label: 'New',
            name: 'New',
            bgColor: '#e95646',
          }
        ]
      }
      if (name === 'sizePricing') {
        this.priceActiveName = 2;
        this.rightBtns = []
      }
      this.changeTabList(this.selectArea)
    },
    rightClickHandler(name) {
      if (this.priceActiveName === 0) {
        this.show_edit = false
        if (name == 'Edit'){
          this.show_edit = true
          this.rightBtns = [
            {
              label: 'Cancel',
              name: 'Cancel',
              bgColor: '#F5F6FB',
              borderColor:"#000",
              textColor:'#000'
            },
            {
              label: 'Save',
              name: 'Save',
              bgColor: '#000000',
            }
          ]
        }else {
          this.rightBtns = [
            {
              label: 'Edit',
              name: 'Edit',
              bgColor: '#e95646',
            }
          ]
          if (name == 'Save'){
            let price = []
            this.show_edit = false
            this.operationStack.forEach(v=>{
              this.options.forEach(a=>{
                if (a.price == this.data[v.cellIndex].cells[v.rowIndex]){
                  price.push({
                    pickup_zone:this.data[v.cellIndex].code,
                    delivery_zone:this.codes[v.rowIndex],
                    tier_id:a.id
                  })
                }
              })
            })
            batchSaveZonePrices({
              ma_code:this.selectArea,
              prices:price
            }).then(res=>{
                if (res.code == 200){
                  this.$message({
                    type:"success",
                    message:'successfully updated'
                  })
                  this.getPricingMatrixDataHandle()
                  this.saveHandle()
                }
            })
          }
          if (name == 'Cancel'){
            this.getPricingMatrixDataHandle()
            this.show_edit = false; // 关闭编辑状态
            this.saveHandle()
            this.data.forEach((row) => {
              row.dropdowns = row.dropdowns.map(() => false); // 关闭所有下拉框
            });
          }
        }
      }
      if (this.priceActiveName === 1) {
        this.$refs.tierPricing.tierTitle = 'Create a tire pricing'
          this.$refs.tierPricing.tierCreatDialog = true
      }
    },
    handleItemClick(name){
      this.selectArea = name.ma_code
      this.priceLoading = true
      this.changeTabList(name.ma_code)
    },
    changeTabList(ma_code){
      if (this.priceActiveName == 0){
        this.getTireList()
        this.getPricingMatrixDataHandle()
      }else if (this.priceActiveName == 1){
        this.getTireList()
        this.getTierDropdownlistHandle()
      }else if (this.priceActiveName == 2){
        this.$refs.sizeList.selectArea = ma_code
        this.$refs.sizeList.getSizeCoefficientsHandle()
      }
    },
    updateList(){
      this.getTireList()
      this.getTierDropdownlistHandle()
    }
  }
}
</script>

<template>
  <div  v-loading="priceLoading">
    <page-title
      :left-btns="leftBtns"
      :right-btns="rightBtns"
      @leftClick="leftClickHandler"
      @rightClick="rightClickHandler"
    >
      <template v-slot:left-addon>
        <span class="ml-5 leading-8">Metropolitan Area:
              <el-dropdown>
                  <span class="el-dropdown-link">
                    {{selectArea}}  <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in areaMenuItems"
                        :key="index"
                        @click.native="handleItemClick(item)">
                        {{ item.ma_code }}
                      </el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>
        </span>
      </template>
      <template v-slot:right-addon v-if="priceActiveName === 0 && this.rightBtns.length > 1">
        <div>
          <img class="w-4 mt-2 mr-4" v-if="operationStack.length > 0" @click="undoHandle" src="../../assets/pricing/left.png" alt="">
          <img class="w-4 mt-2 mr-4" v-else src="../../assets/pricing/left_dis.png" alt="">
        </div>
        <div>
          <img class="w-4 mt-2 mr-4" v-if="undoStack.length > 0" @click="redoHandle" src="../../assets/pricing/right.png" alt="">
          <img class="w-4 mt-2 mr-4" v-else src="../../assets/pricing/right_dis.png" alt="">
        </div>
      </template>
    </page-title>
    <div v-if="priceActiveName == 0">
      <table>
        <thead>
        <tr>
          <th class="black_box"></th>
          <th class="black_box">Code</th>
          <th v-for="code in codes">{{ code }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th class="black_box">Code</th>
          <th class="black_box">Name</th>
          <td v-for="name in names" class="small_name">{{ name }}</td>
        </tr>
        <tr v-for="(row, index) in data">
          <th>{{ row.code }}</th>
          <th class="small_name">{{ row.name }}</th>
          <td v-for="(cell, cellIndex) in row.cells"
              :style="{ backgroundColor: row.cellColors[cellIndex] }"
              :class="show_edit === false ?'unset_bac':''"
          >
            <div class="dropdown">
            <span class="dropdown-toggle" @click="toggleDropdown(index, cellIndex)"  style="font-size: 14px">
              <span  v-if="cell === unsetDefaultValue">
              {{ unsetDefaultValue }}
              </span>
            <span v-else style="color: #000" >${{ cell }}</span>
              <i class="el-icon-arrow-down" v-if="show_edit" style="font-size: 14px"></i>
            </span>
              <div v-show="row.dropdowns[cellIndex]" class="dropdown-menu">
                <div v-for="option in options" class="dropdown-item" @click="selectOption(index, cellIndex, option)">
                  <div class="dropdown_label" :class="option.price == 'Unset'?'unset_border':''"  :style="{ backgroundColor: option.color}">
                    ${{ option.price }}
                  </div>
                  <div>
                    <span v-if="option.value != 'Unset'">{{ option.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="priceActiveName == 1">
      <tierPricing ref="tierPricing" :tirelist="tirelist" :selectArea="selectArea" :tierList="options" @updateList="updateList"></tierPricing>
    </div>
    <div v-if="priceActiveName == 2">
      <size-pricing :selectArea="selectArea" ref="sizeList" @updateList="updateList" @closeLoading="priceLoading = false"></size-pricing>
    </div>
  </div>
</template>

<style scoped lang="less">
.el-popper[x-placement^=bottom]{
  max-height: 200px;
  overflow-y: auto;
}
table {
  border-collapse: collapse;
  font-family: PingFangSC, PingFang SC;
  font-weight: normal;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: right;
  font-style: normal;
  margin-top: 16px;
  .small_name{
    background-color: #FFFFFF;
    font-family: SFPro, SFPro;
    font-weight: 400;
    font-size: 10px;
    color: #000000;
    line-height: 12px;
    text-align: center;
    font-style: normal;
  }
  .unset_bac{
    background: #CCCCCC;
    border: 2px solid #D7D7D7;
    color: #FFFFFF;
  }
  .black_box{
    background: #000000;
    color: #FFFFFF;
  }
}
.unset_bac_box{
  background-color: #D7D7D7;
}
th, td {
  border: 2px solid  #D7D7D7;
  padding: 8px;
  text-align: center;
}


th {
  background-color: #FFFFFF;
  width: 84px;
  height: 40px;
  text-align: center;
  font-weight: normal;
  font-size: 14px;
  border: 2px solid  #D7D7D7;
}

.unset {
  background: #CCCCCC;
  color: #FFFFFF;
}
.dropdown {
  position: relative;
}

.dropdown-toggle {
  cursor: pointer;
}

.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 5px;
  vertical-align: middle;
  border-top: 5px solid;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}

.dropdown-menu {
  position: absolute;
  top: 20px !important;
  z-index: 1;
  padding: 5px 0;
  background: #FFFFFF;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.1);
  border-radius: 8px;
  border: 1px solid #D8D8D8;
}

.dropdown-item {
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  width: 180px;
  line-height: 32px;
  .dropdown_label{
    width: 80px;
    height: 32px;
    border-radius: 16px;
  }
  .unset_border{
    border: 1px solid #E0E0E0;
  }
}

.dropdown-item:hover {
  background-color: #f2f2f2;
}

.dropdown-item span {
  float: right;
  color: #999;
}

</style>
